"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _cccisdWordtimingeditor = _interopRequireDefault(require("cccisd-wordtimingeditor"));
var _pick2 = _interopRequireDefault(require("lodash/pick"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _wt = _interopRequireDefault(require("./wt.svg"));
var _bubbleLines = _interopRequireDefault(require("cccisd-icons/bubble-lines3"));
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _utils = require("./utils.js");
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _reactRedux = require("react-redux");
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return r; }; var t, r = {}, e = Object.prototype, n = e.hasOwnProperty, o = "function" == typeof Symbol ? Symbol : {}, i = o.iterator || "@@iterator", a = o.asyncIterator || "@@asyncIterator", u = o.toStringTag || "@@toStringTag"; function c(t, r, e, n) { return Object.defineProperty(t, r, { value: e, enumerable: !n, configurable: !n, writable: !n }); } try { c({}, ""); } catch (t) { c = function c(t, r, e) { return t[r] = e; }; } function h(r, e, n, o) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype); return c(a, "_invoke", function (r, e, n) { var o = 1; return function (i, a) { if (3 === o) throw Error("Generator is already running"); if (4 === o) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var u = n.delegate; if (u) { var c = d(u, n); if (c) { if (c === f) continue; return c; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (1 === o) throw o = 4, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = 3; var h = s(r, e, n); if ("normal" === h.type) { if (o = n.done ? 4 : 2, h.arg === f) continue; return { value: h.arg, done: n.done }; } "throw" === h.type && (o = 4, n.method = "throw", n.arg = h.arg); } }; }(r, n, new Context(o || [])), !0), a; } function s(t, r, e) { try { return { type: "normal", arg: t.call(r, e) }; } catch (t) { return { type: "throw", arg: t }; } } r.wrap = h; var f = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var l = {}; c(l, i, function () { return this; }); var p = Object.getPrototypeOf, y = p && p(p(x([]))); y && y !== e && n.call(y, i) && (l = y); var v = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(l); function g(t) { ["next", "throw", "return"].forEach(function (r) { c(t, r, function (t) { return this._invoke(r, t); }); }); } function AsyncIterator(t, r) { function e(o, i, a, u) { var c = s(t[o], t, i); if ("throw" !== c.type) { var h = c.arg, f = h.value; return f && "object" == _typeof(f) && n.call(f, "__await") ? r.resolve(f.__await).then(function (t) { e("next", t, a, u); }, function (t) { e("throw", t, a, u); }) : r.resolve(f).then(function (t) { h.value = t, a(h); }, function (t) { return e("throw", t, a, u); }); } u(c.arg); } var o; c(this, "_invoke", function (t, n) { function i() { return new r(function (r, o) { e(t, n, r, o); }); } return o = o ? o.then(i, i) : i(); }, !0); } function d(r, e) { var n = e.method, o = r.i[n]; if (o === t) return e.delegate = null, "throw" === n && r.i["return"] && (e.method = "return", e.arg = t, d(r, e), "throw" === e.method) || "return" !== n && (e.method = "throw", e.arg = new TypeError("The iterator does not provide a '" + n + "' method")), f; var i = s(o, r.i, e.arg); if ("throw" === i.type) return e.method = "throw", e.arg = i.arg, e.delegate = null, f; var a = i.arg; return a ? a.done ? (e[r.r] = a.value, e.next = r.n, "return" !== e.method && (e.method = "next", e.arg = t), e.delegate = null, f) : a : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, f); } function w(t) { this.tryEntries.push(t); } function m(r) { var e = r[4] || {}; e.type = "normal", e.arg = t, r[4] = e; } function Context(t) { this.tryEntries = [[-1]], t.forEach(w, this), this.reset(!0); } function x(r) { if (null != r) { var e = r[i]; if (e) return e.call(r); if ("function" == typeof r.next) return r; if (!isNaN(r.length)) { var o = -1, a = function e() { for (; ++o < r.length;) if (n.call(r, o)) return e.value = r[o], e.done = !1, e; return e.value = t, e.done = !0, e; }; return a.next = a; } } throw new TypeError(_typeof(r) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, c(v, "constructor", GeneratorFunctionPrototype), c(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = c(GeneratorFunctionPrototype, u, "GeneratorFunction"), r.isGeneratorFunction = function (t) { var r = "function" == typeof t && t.constructor; return !!r && (r === GeneratorFunction || "GeneratorFunction" === (r.displayName || r.name)); }, r.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, c(t, u, "GeneratorFunction")), t.prototype = Object.create(v), t; }, r.awrap = function (t) { return { __await: t }; }, g(AsyncIterator.prototype), c(AsyncIterator.prototype, a, function () { return this; }), r.AsyncIterator = AsyncIterator, r.async = function (t, e, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(h(t, e, n, o), i); return r.isGeneratorFunction(e) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, g(v), c(v, u, "Generator"), c(v, i, function () { return this; }), c(v, "toString", function () { return "[object Generator]"; }), r.keys = function (t) { var r = Object(t), e = []; for (var n in r) e.unshift(n); return function t() { for (; e.length;) if ((n = e.pop()) in r) return t.value = n, t.done = !1, t; return t.done = !0, t; }; }, r.values = x, Context.prototype = { constructor: Context, reset: function reset(r) { if (this.prev = this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(m), !r) for (var e in this) "t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0][4]; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(r) { if (this.done) throw r; var e = this; function n(t) { a.type = "throw", a.arg = r, e.next = t; } for (var o = e.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i[4], u = this.prev, c = i[1], h = i[2]; if (-1 === i[0]) return n("end"), !1; if (!c && !h) throw Error("try statement without catch or finally"); if (null != i[0] && i[0] <= u) { if (u < c) return this.method = "next", this.arg = t, n(c), !0; if (u < h) return n(h), !1; } } }, abrupt: function abrupt(t, r) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var n = this.tryEntries[e]; if (n[0] > -1 && n[0] <= this.prev && this.prev < n[2]) { var o = n; break; } } o && ("break" === t || "continue" === t) && o[0] <= r && r <= o[2] && (o = null); var i = o ? o[4] : {}; return i.type = t, i.arg = r, o ? (this.method = "next", this.next = o[2], f) : this.complete(i); }, complete: function complete(t, r) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && r && (this.next = r), f; }, finish: function finish(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[2] === t) return this.complete(e[4], e[3]), m(e), f; } }, "catch": function _catch(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[0] === t) { var n = e[4]; if ("throw" === n.type) { var o = n.arg; m(e); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(r, e, n) { return this.delegate = { i: x(r), r: e, n: n }, "next" === this.method && (this.arg = t), f; } }, r; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Boilerplate = window.cccisd.boilerplate;
var WordTimings = /*#__PURE__*/function (_React$Component) {
  function WordTimings(props) {
    var _this;
    _classCallCheck(this, WordTimings);
    _this = _callSuper(this, WordTimings, [props]);
    _defineProperty(_this, "generateTimings", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var language, response, wordTimings, duration, words, contentTranscript, speechTranscript;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            language = _this.state.language;
            _this.setState({
              loading: true
            });
            _context.next = 4;
            return _cccisdAxios["default"].post(Boilerplate.route('audio.production.asset', {
              fileId: _this.props.meta.audio.id
            }), {
              transcript: _this.props.content,
              lang: language
            });
          case 4:
            response = _context.sent;
            if (!(response.data.status === 'error')) {
              _context.next = 9;
              break;
            }
            (0, _cccisdNotification["default"])({
              type: 'danger',
              message: response.data.errorMessage
            });
            _this.setState({
              loading: false
            });
            return _context.abrupt("return");
          case 9:
            wordTimings = (0, _utils.adjustTimings)(_this.props.content, response.data.timingsArray);
            duration = response.data.duration; // Save updated timings again
            _context.next = 13;
            return _cccisdAxios["default"].put(Boilerplate.route('audio.production.asset', {
              fileId: _this.props.meta.audio.id
            }), {
              result: {
                duration: duration,
                wordTimings: wordTimings,
                language: language
              }
            });
          case 13:
            words = (0, _utils.getWords)(_this.props.content);
            contentTranscript = words.join(' ');
            speechTranscript = response.data.speechTranscript || contentTranscript;
            _this.setState({
              loading: false,
              askToReplaceWithSpeechTranscript: !(0, _utils.isTranscriptTheSame)(contentTranscript, speechTranscript),
              speechTranscript: response.data.speechTranscript ? '<p>' + response.data.speechTranscript + '</p>' : undefined,
              speechTimingsArray: response.data.timingsArray,
              content: _this.props.content,
              wordTimings: wordTimings,
              duration: duration
            });
            if (!words.length) {
              _this.onReplaceWithSpeechTranscript(true);
            }
          case 18:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    _defineProperty(_this, "removeTimings", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var response, audio;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _this.setState({
              loading: true
            });
            _context2.next = 3;
            return _cccisdAxios["default"]["delete"](Boilerplate.route('audio.production.asset.destroyAssetTimings', {
              fileId: _this.props.meta.audio.id
            }));
          case 3:
            response = _context2.sent;
            if (!(response.data.status === 'success')) {
              _context2.next = 11;
              break;
            }
            audio = _objectSpread({}, _this.props.meta.audio);
            delete audio.duration;
            delete audio.wordTimings;
            delete audio.language;
            _this.props.setContent(_this.props.content, _objectSpread(_objectSpread({}, _this.props.meta), {}, {
              audio: audio
            }));
            return _context2.abrupt("return");
          case 11:
            (0, _cccisdNotification["default"])({
              message: 'Failed to remove word timings',
              type: 'danger'
            });
            _this.setState({
              loading: false
            });
          case 13:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    })));
    _defineProperty(_this, "removeTimings", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var response, audio;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _this.setState({
              loading: true
            });
            _context3.next = 3;
            return _cccisdAxios["default"]["delete"](Boilerplate.route('audio.production.asset.destroyAssetTimings', {
              fileId: _this.props.meta.audio.id
            }));
          case 3:
            response = _context3.sent;
            if (!(response.data.status === 'success')) {
              _context3.next = 11;
              break;
            }
            audio = _objectSpread({}, _this.props.meta.audio);
            delete audio.duration;
            delete audio.wordTimings;
            delete audio.language;
            _this.props.setContent(_this.props.content, _objectSpread(_objectSpread({}, _this.props.meta), {}, {
              audio: audio
            }));
            return _context3.abrupt("return");
          case 11:
            (0, _cccisdNotification["default"])({
              message: 'Failed to remove word timings',
              type: 'danger'
            });
            _this.setState({
              loading: false
            });
          case 13:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    })));
    _defineProperty(_this, "_onEditorChange", function (wordTimings) {
      _this.setState({
        wordTimings: wordTimings.map(function (item) {
          return (0, _pick2["default"])(item, ['start', 'end', 'word']);
        })
      });
    });
    _defineProperty(_this, "_onSubmit", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      var result;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            result = (0, _pick2["default"])(_this.state, ['duration', 'wordTimings', 'language', 'content']);
            _context4.next = 3;
            return _cccisdAxios["default"].put(Boilerplate.route('audio.production.asset', {
              fileId: _this.props.meta.audio.id
            }), {
              result: result
            });
          case 3:
            _this.props.setContent(_this.state.content, _objectSpread(_objectSpread({}, _this.props.meta), {}, {
              audio: _objectSpread(_objectSpread(_objectSpread({}, _this.props.meta.audio), result), {}, {
                transcript: _this.state.content
              })
            }));
          case 4:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    })));
    _defineProperty(_this, "onReplaceWithSpeechTranscript", /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(replace) {
        var content, wordTimings;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              content = replace ? _this.state.speechTranscript : _this.props.content;
              wordTimings = (0, _utils.adjustTimings)(content, _this.state.speechTimingsArray);
              _this.setState({
                askToReplaceWithSpeechTranscript: false,
                wordTimings: wordTimings,
                content: content
              });
            case 3:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      return function (_x) {
        return _ref5.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "isTooltip", function () {
      return (0, _get2["default"])(_this.props, 'meta.information') || (0, _get2["default"])(_this.props, 'meta.tooltips');
    });
    _defineProperty(_this, "showWordTimingsEditor", function () {
      return _this.state.wordTimings.length > 0 && !_this.state.loading;
    });
    _defineProperty(_this, "showMissingWordTimingsMessage", function () {
      return !_this.state.wordTimings.length && !_this.state.loading;
    });
    _defineProperty(_this, "replaceWithSpeechTranscript", function () {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("h4", null, "The transcription of the audio is different from the existing text. Do you want to use it instead?"), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginTop: '2em'
        }
      }, /*#__PURE__*/_react["default"].createElement("strong", null, "Existing text:")), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          paddingLeft: '2em'
        },
        dangerouslySetInnerHTML: {
          __html: _this.props.content
        }
      }), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginTop: '2em'
        }
      }, /*#__PURE__*/_react["default"].createElement("strong", null, "Audio transcription:")), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          paddingLeft: '2em'
        },
        dangerouslySetInnerHTML: {
          __html: _this.state.speechTranscript
        }
      }), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginTop: '2em'
        }
      }, /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-primary",
        style: {
          marginRight: '1em'
        },
        onClick: function onClick() {
          return _this.onReplaceWithSpeechTranscript(true);
        }
      }, "Use audio transcription"), /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-primary",
        onClick: function onClick() {
          return _this.onReplaceWithSpeechTranscript(false);
        }
      }, "Keep existing text")));
    });
    _defineProperty(_this, "render", function () {
      if (_this.isTooltip()) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "alert alert-danger",
          style: {
            margin: 0
          }
        }, "You cannot use word timings along with tooltips");
      }
      if (_this.state.askToReplaceWithSpeechTranscript) {
        return _this.replaceWithSpeechTranscript();
      }
      return /*#__PURE__*/_react["default"].createElement("div", null, _this.state.loading && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
        loading: true,
        type: "inline"
      }), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginTop: '1em',
          marginBottom: '1em'
        },
        className: "text-center"
      }, "Please be patient, it may take a few minutes")), _this.showMissingWordTimingsMessage() && /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginTop: '1em',
          marginBottom: '1em'
        },
        className: "text-center"
      }, "Transcription for the audio file can not be generated."), _this.showWordTimingsEditor() && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h4", null, "Edit Word Timings"), /*#__PURE__*/_react["default"].createElement(_cccisdWordtimingeditor["default"], {
        onTimingChange: _this._onEditorChange,
        onSubmit: _this._onSubmit,
        timings: _this.state.wordTimings,
        audioFile: _this.props.meta.audio.url,
        width: 550,
        showSave: false,
        duration: _this.state.duration,
        generateTimings: _this.generateTimings,
        removeTimings: _this.removeTimings
      }), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginTop: '1em'
        }
      }, /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-primary",
        onClick: _this._onSubmit
      }, "Submit"))));
    });
    _this.state = {
      loading: false,
      askToReplaceWithSpeechTranscript: false,
      speechTranscript: undefined,
      speechTimingsArray: [],
      wordTimings: (0, _get2["default"])(_this.props, 'meta.audio.wordTimings', []),
      content: _this.props.content,
      duration: (0, _get2["default"])(_this.props, 'meta.audio.duration', 0),
      language: (0, _utils.mapLanguage)(props.language)
    };
    _this.generateTimings = _this.generateTimings.bind(_this);
    _this.removeTimings = _this.removeTimings.bind(_this);
    _this.onReplaceWithSpeechTranscript = _this.onReplaceWithSpeechTranscript.bind(_this);
    return _this;
  }
  _inherits(WordTimings, _React$Component);
  return _createClass(WordTimings, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.isTooltip()) {
        return;
      }
      if (this.showWordTimingsEditor()) {
        return;
      }
      this.generateTimings();
    }
  }]);
}(_react["default"].Component);
_defineProperty(WordTimings, "propTypes", {
  content: _propTypes["default"].string,
  meta: _propTypes["default"].object,
  setContent: _propTypes["default"].func,
  language: _propTypes["default"].string
});
var addIcon = function addIcon(content) {
  var wordTimings = (0, _get2["default"])(content, 'meta.audio.wordTimings', []);
  if (wordTimings.length === 0) {
    return false;
  }
  return /*#__PURE__*/_react["default"].createElement("i", {
    title: "with timings"
  }, /*#__PURE__*/_react["default"].createElement(_bubbleLines["default"], null));
};
var WordTimingsLanguageWrapper = function WordTimingsLanguageWrapper(props) {
  var language = (0, _reactRedux.useSelector)(function (state) {
    return state.flow.builder.language;
  });
  return /*#__PURE__*/_react["default"].createElement(WordTimings, _extends({}, props, {
    language: language
  }));
};
var _default = exports["default"] = {
  name: 'cccisdWordTimings',
  tooltip: 'Word Timings',
  image: _wt["default"],
  title: 'Word Timings',
  component: WordTimingsLanguageWrapper,
  addIcon: addIcon,
  disableCondition: function disableCondition(content, meta, currentElement) {
    return meta && meta.audio && meta.audio.resourceId ? false : true;
  }
};